import partner_1 from '../assets/partners/partner_1.png';
import partner_2 from '../assets/partners/partner_2.png';
import partner_3 from '../assets/partners/partner_3.png';
import partner_5 from '../assets/partners/partner_5.png';
import partner_6 from '../assets/partners/partner_6.png';
import partner_7 from '../assets/partners/partner_7.png';

const partners = [
  { name: 'Stripe', logo: partner_1, alt: 'Stripe' },
  { name: 'Paypal', logo: partner_2, alt: 'Paypal' },
  { name: 'Stocktwits', logo: partner_3, alt: 'Stocktwits' },
  { name: 'Cloud Partner', logo: partner_5, alt: 'Cloud Logo' },
  { name: 'Bull Logo', logo: partner_6, alt: 'Bull Logo' },
  { name: 'X', logo: partner_7, alt: 'X', onLight: 'dark' },
];

const Partners = ({ variant = 'classic' } = {}) => {
  if (variant === 'v2') {
    return (
      <section className="relative overflow-hidden border-y border-slate-200/70 bg-[#f8f7fc] py-6 sm:py-8">
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1 text-center">
            <p className="text-[11px] font-bold tracking-[0.28em] text-[#6756FE] uppercase">
              Partners
            </p>
            <span className="text-slate-300" aria-hidden>
              ·
            </span>
            <h2 className="text-base font-bold tracking-tight text-slate-900 sm:text-lg">
              Trusted by several companies around the world.
            </h2>
          </div>

          <div className="mt-4 grid grid-cols-3 gap-2 sm:grid-cols-6 sm:gap-3">
            {partners.map((partner) => (
              <div
                key={partner.name}
                className="group flex h-14 items-center justify-center rounded-xl border border-slate-200/80 bg-white px-2 shadow-sm shadow-slate-200/30 transition duration-300 hover:border-[#6756FE]/25 hover:shadow-md hover:shadow-[#6756FE]/10 sm:h-16 sm:px-3"
              >
                {partner.onLight === 'dark' ? (
                  <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-lg bg-black shadow-sm transition duration-300 group-hover:scale-105 sm:h-10 sm:w-10">
                    <img
                      src={partner.logo}
                      alt={partner.alt}
                      className="h-5 w-5 object-contain sm:h-6 sm:w-6"
                    />
                  </div>
                ) : (
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className="max-h-7 w-auto max-w-[5.5rem] object-contain transition duration-300 group-hover:scale-105 sm:max-h-8 sm:max-w-[6.5rem]"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-black text-white py-16 px-4 md:px-20">
      <div className="text-center mb-2">
        <h2 className="text-3xl font-bold">Partners</h2>
        <p className="text-[#6756FE]">
          Trusted by several companies around the world.
        </p>
      </div>

      <div className="flex flex-wrap justify-between items-center">
        {partners.map((partner, idx) => (
          <div key={idx} className="flex flex-col items-center">
            <img
              src={partner.logo}
              alt={partner.alt}
              className="h-12 object-contain"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Partners;
